import { InjectionToken } from '@angular/core';

import { AttachmentItemTranslations } from '@core/attachments-ui';

export interface CandidateQuestionsModuleTranslations {
  titles: {
    questions: string;
    referralQuestions?: string;
    questionnaires: string;
  };

  questions: {
    outOf: string;
    noAnswer: string;
  };

  referralQuestions?: {
    referredBy: string;
    deletedReferrer: string;
    for: string;
  };

  boolean: {
    yes: string;
    no: string;
  };

  attachmentComponent: AttachmentItemTranslations;
  disqualifyReasonTooltip: string;
}

export const CandidateQuestionsTranslations =
  new InjectionToken<CandidateQuestionsModuleTranslations>('CandidateQuestionsModuleTranslations');
